"use strict";

import { AppDispatcher } from 'Dispatcher';
import { FormFilterConstants } from "Constants/Forms/FormFilterConstants";
export function formFilterInitialize(formObj, _ref) {
  var form = _ref.form,
      popup = _ref.popup;
  AppDispatcher.dispatch({
    actionType: FormFilterConstants.FORM_FILTER_INITIALIZE,
    formObj: formObj,
    formInst: form,
    popupInst: popup
  });
}
export function formFilterNavigateToParent(UUID) {
  AppDispatcher.dispatch({
    actionType: FormFilterConstants.FORM_FILTER_NAVIGATE_TO_PARENT,
    UUID: UUID
  });
}
export function formFilterApply(UUID) {
  AppDispatcher.dispatch({
    actionType: FormFilterConstants.FORM_FILTER_APPLY,
    UUID: UUID
  });
}
export function formFilterUpdate(_ref2) {
  var nextData = _ref2.nextData,
      UUID = _ref2.UUID;
  AppDispatcher.asyncDispatch({
    actionType: FormFilterConstants.FORM_FILTER_UPDATE,
    nextData: nextData,
    UUID: UUID
  });
}